import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "cayus-cta-section";

/** Enregistre un clic sur le CTA de démo : côté serveur, dans le dataLayer, et en mémoire de session. */
export const trackCtaClick = (section, language) => {
  try {
    sessionStorage.setItem(KEY, section);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "book_demo_click", section, language });
    if (typeof window.gtag === "function") {
      window.gtag("event", "book_demo_click", { section, language });
    }
  } catch (e) {
    /* le suivi ne doit jamais casser le clic */
  }
  axios.post(`${API}/track/cta`, { section, page: window.location.pathname, language }).catch(() => {});
};

/** Dernière section d'où le visiteur a cliqué, pour attribuer la demande de démo. */
export const lastCtaSection = () => {
  try {
    return sessionStorage.getItem(KEY) || "direct";
  } catch (e) {
    return "direct";
  }
};
